import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();


export const useRegisterStore = defineStore("register", {
    state: () => {
        return {
            loadings: false,
            isRegisters: false
        };
    },

    getters: {
        loading: (state) => state.loadings,
        isRegister: (state) => state.isRegisters,
    },

    actions: {
        post(data) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'register',
                data: {
                    ...data
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        localStorage.refresh = res.data.data.refresh
                        localStorage.token = res.data.data.token
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
        checkUsername(username) {
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'register/username/check',
                params: {
                    username: username
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data.msg);
                    });
            });
        },
        checkEmail(email) {
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'register/email/check',
                params: {
                    email: email
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        reject(error.response.data.msg);
                    });
            });
        },
        confirmEmail(code) {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'register/email/confirm',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    code: code
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
        reSendCode() {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'register/email/sendcode',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        }
    },
});